import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'card-connect',
  templateUrl: './card-connect.component.html',
  styleUrls: ['./card-connect.component.scss']
})
export class CardConnectComponent implements OnInit {

  @Input() paymentType: string;
  paymentTypes: Array<string> = ["ACH", "CARD"];
  @ViewChild('tokenframe') iframe: ElementRef;

  cardConnectSrc: string = "";

  cardConnectEventData: any;

  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit() { 
    console.log("selected payment type::", this.paymentType);
    // this.initCardConnectSrc();
  }

  ngAfterViewInit() {
    // let doc =  this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
    // console.log("iframe: ", doc);
    let that = this;
    window.addEventListener('message', function(event) {
      that.cardConnectEventData = null;
      that.cardConnectEventData = JSON.parse(event.data);
      // console.log("Event data from Card Connect::", that.cardConnectEventData);
    //   const element: HTMLIFrameElement = document.getElementById('tokenframe') as HTMLIFrameElement;
    // const iframe = element.contentWindow;
    // console.log("iframe::", that.iframe.nativeElement.contentWindow);
    // let doc =  that.iframe.nativeElement.contentDocument || that.iframe.nativeElement.contentWindow;
    // console.log("iframe: ", doc);
      // const iframe =  <HTMLIFrameElement> document.getElementById('tokenframe');
      // var innerDoc = (iframe.contentDocument) 
      //          ? iframe.contentDocument 
      //          : iframe.contentWindow.document;
      // var ulObj = <HTMLInputElement>innerDoc.getElementById("cccvvfield");
      // console.log("cvv value::", ulObj.value)
    }, false);
    // const element: HTMLIFrameElement = document.getElementById('tokenframe') as HTMLIFrameElement;
    // const iframe = element.contentWindow;
    // // console.log("iframe::", that.iframe.contentWindow);
    // // let doc =  this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
    // console.log("iframe: ", iframe);
  }

  initCardConnectSrc() {
    this.cardConnectSrc = "";
    if(this.paymentType == this.paymentTypes[0]) {
      this.cardConnectSrc = "https://fts.cardconnect.com:6443/itoke/ajax-tokenizer.html?css%3D%252Eerror%7Bcolor%3A%2520red%3B%7D&fullmobilekeyboard=true&formatinput=true&css="+this.getCss();
    } else if(this.paymentType == this.paymentTypes[1]) {
      this.cardConnectSrc = "https://fts.cardconnect.com:6443/itoke/ajax-tokenizer.html?css%3D%252Eerror%7Bcolor%3A%2520red%3B%7D&fullmobilekeyboard=true&formatinput=true&useexpiry=true&usecvv=true"+this.getCss();
    }

    const iframe =  <HTMLIFrameElement> document.getElementById('tokenframe');
    iframe.src = this.cardConnectSrc;
  }

  getCss() {
    return encodeURIComponent(
      'input{width:60%;margin-left:-8px;background-color:#e9ecef;font-size:12.8px;font-weight:400;line-height:1.5;color:#4c4c4c;border:none;padding: .375rem .75rem;border-radius: .25rem;font-family:nissan-brand-regular,Helvetica,Arial,sans-serif!important;}' + 
      'label{margin: 8px 0px 8px -8px;display: inline-block;color: #343434;font-size: 14px;line-height:1.2;-webkit-font-smoothing: subpixel-antialiased;font-weight: 400;word-break: break-word;font-family:nissan-brand-regular,Helvetica,Arial,sans-serif!important;}' +
      'select{width: 30%;margin: 0px -5px 0px -8px;outline: none !important;border: 1px solid #dadada;border-radius: 5px;font-size: 12.8px;padding: 5px;color: #999;box-shadow: 0px 0px 0px 2px rgba(237, 237, 237, 0.6);}'
    );
    // return "input%7B%0Awidth%3A60%25%3B%0Abackground-color%3A%23e9ecef%3B%0Afont-size%3A12.8px%3B%0Afont-weight%3A400%3B%0Aline-height%3A1.5%3B%0Acolor%3A%234c4c4c%3B%0Aborder%3Anone%3B%0Apadding%3A%20.375rem%20.75rem%3B%0Aborder-radius%3A%20.25rem%3B%0A%7D";
    // return ".error%7B%0Acolor%3Ared%3B%0A%7D%0Ainput%7B%0Awidth%3A60%25%3B%0Abackground-color%3A%23e9ecef%3B%0Afont-size%3A12.8px%3B%0Afont-weight%3A400%3B%0Aline-height%3A1.5%3B%0Acolor%3A%234c4c4c%3B%0Aborder%3Anone%3B%0A%7D";
    // return "%2Eerror%7Bcolor%3Ared%3B%7Dinput%7Bwidth%3A60%25%3Bbackground-color%3A%23e9ecef%3Bfont-size%3A12.8px%3Bfont-weight%3A400%3Bline-height%3A1.5%3Bcolor%3A%234c4c4c%3Bborder%3Anone%3B%7D";
  }

  resetIframe() {
    let container = document.getElementById("tokeFrameDiv");
    let content = container.innerHTML;
    container.innerHTML= content;
  }

}
